<div class="card m-3">
  <ng-content></ng-content>
</div>
